import { AddressViewConfig, BaseFieldConfig } from '@bhtp-client-web/component';
import { TravelerDetailViewConfig } from '@bhtp-client-web/component';

export class PrimaryTravelerFieldConfig extends TravelerDetailViewConfig {
    public addressConfig: AddressViewConfig;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/primary-traveler-field.config.ts